import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import { IconGroceries } from '@op/opds.opux-icons/expenses';
import { IconSavings } from '@op/opds.opux-icons/misc';
import Circle from './Circle';
import TimeSpanSection from './TimeSpanSection';

const TimeSpan = (): ReactElement => {
  const list1 = useMessage('course4.time_span.list1');
  const list2 = useMessage('course4.time_span.list2');
  const list3 = useMessage('course4.time_span.list3');

  return (
    <div className="investoracademy-timespan-container">
      <TimeSpanSection
        titleId="course4.time_span.assets"
        list={list1}
        messageId="course4.time_span.list1"
        circles={[
          { key: 'circle1', element: <Circle icon={<IconGroceries />} /> },
          {
            key: 'circle2',
            element: (
              <Circle
                icon={
                  <span>
                    <Message id="course4.time_span.year1" />
                  </span>
                }
              />
            ),
          },
        ]}
        style={{ paddingRight: '290px' }}
      />
      <TimeSpanSection
        titleId="course4.time_span.prep"
        list={list2}
        messageId="course4.time_span.list2"
        circles={[
          { key: 'circle3', element: <Circle icon={<IconSavings />} /> },
          {
            key: 'circle4',
            element: (
              <Circle
                icon={
                  <span>
                    <Message id="course4.time_span.year1" />
                  </span>
                }
              />
            ),
          },
          {
            key: 'circle5',
            element: (
              <Circle
                icon={
                  <span>
                    <Message id="course4.time_span.year2" />
                  </span>
                }
              />
            ),
          },
        ]}
      />
      <TimeSpanSection
        titleId="course4.time_span.invest"
        list={list3}
        messageId="course4.time_span.list3"
        circles={[
          { key: 'circle6', element: <Circle icon={<IconGroceries />} /> },
          {
            key: 'circle7',
            element: (
              <Circle
                icon={
                  <span>
                    <Message id="course4.time_span.year2" />
                  </span>
                }
              />
            ),
            isLast: true,
          },
        ]}
        style={{ paddingRight: '40px' }}
      />
    </div>
  );
};

export default TimeSpan;
